'use client'

import BaseAvatar, { AvatarSkeleton } from 'app/_components/Avatar'
import EmployeeDetails, {
  EmployeeDetailsSkeleton,
} from 'app/_components/EmployeeDetails'
import { useEffect, useState } from 'react'
import { getEmployee, getPerson } from './actions'

type User = {
  id: string
  name: string | null
  alias: string | null
  email: string | null
  image: string | null
}

async function getUser(id: string): Promise<User | null> {
  const user = await getEmployee({ id })
  if (user) return user
  const person = await getPerson({ id })
  if (person)
    return {
      ...person,
      name: `${person.firstName} ${person.lastName}`,
      alias: `${person.firstName?.slice(0, 1).toLocaleLowerCase()} ${person.lastName?.slice(0, 1).toLocaleLowerCase()}`,
      email: person.email,
    }
  return null
}

// @TODO: why is this functionality not included in EmployeeDetail?
export function Person({ id }: { id: string }) {
  const [isLoading, setIsLoading] = useState(true)
  const [user, setUser] = useState<User | null>(null)

  useEffect(() => {
    async function fetchUser() {
      setIsLoading(true)
      const user = await getUser(id)
      setUser(user)
      setIsLoading(false)
    }
    fetchUser()
  }, [id])

  if (isLoading) return <EmployeeDetailsSkeleton showAvatar />

  return <EmployeeDetails employee={user || undefined} showAvatar />
}

// @TODO: why is this functionality not included in Avatar?
export function Avatar({ id }: { id: string }) {
  const [isLoading, setIsLoading] = useState(true)
  const [user, setUser] = useState<User | null>(null)
  useEffect(() => {
    async function fetchUser() {
      setIsLoading(true)
      const user = await getUser(id)
      setUser(user)
      setIsLoading(false)
    }
    fetchUser()
  }, [id])

  const className = '!h-5 !w-5 !text-[0.5rem]'

  if (isLoading) return <AvatarSkeleton className={className} />

  return <BaseAvatar className={className} employee={user || undefined} />
}
